import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
        providedIn: 'root'
    }
)
export class DataOpsService {
    readonly invoiceIdURL = environment.backendUrl + '/brain-monitor/api/invoice-processing-infos/invoiceIds';
    readonly IMG_JSON_BUNDLE_URL = environment.backendUrl + '/invoicestore/dataops/api/invoice-bundle';
    readonly PDFS_BUNDLE_URL = environment.backendUrl + '/invoicestore/dataops/api/invoice-bundle-pdfs';


    constructor(private http: HttpClient) {
    }

    getInvoiceIdsFromAPI(filters: any, startDate: Date, endDate: Date): Observable<any> {

        let httpParams = new HttpParams();

        if (filters && Object.keys(filters).length > 0) {
            for (const key in filters) {
                httpParams = httpParams.set(key + '.' + filters[key].matchMode, filters[key].value);
            }
        }
        if (startDate) {
            httpParams = httpParams.set('lastModified.greaterThanOrEqual', startDate.toISOString());
        }
        if (endDate) {
            httpParams = httpParams.set('lastModified.lessThanOrEqual', endDate.toISOString());
        }
        return this.http.get<any>(this.invoiceIdURL, {params: httpParams});
    }

    getAttachedDocuments(invoiceIds: number[]): Observable<any> {
        return this.http.post(this.IMG_JSON_BUNDLE_URL, invoiceIds, {responseType: 'blob'});
    }

    getPdfsBundle(invoiceIds: number[]): Observable<any> {
        return this.http.post(this.PDFS_BUNDLE_URL, invoiceIds, {responseType: 'blob'});
    }

}
